const initTabs = () => {
  const tabs = document.querySelectorAll(".tabs .btn")
  const panels = document.querySelectorAll(".panel")
  const tabList = document.querySelector(".tabs")

  // Tab switching
  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.setAttribute("aria-selected", "false"))
      panels.forEach(p => p.classList.add("hidden"))

      tab.setAttribute("aria-selected", "true")
      document.getElementById(tab.getAttribute("aria-controls")).classList.remove("hidden")
    })
  })

  // Keyboard navigation for tabs
  tabList.addEventListener("keydown", event => {
    const index = Array.from(tabs).indexOf(document.activeElement)
    if (index === -1) return
    if (event.key === "ArrowRight") {
      tabs[(index + 1) % tabs.length].focus()
    } else if (event.key === "ArrowLeft") {
      tabs[(index - 1 + tabs.length) % tabs.length].focus()
    }
  })

  // Horizontal scroll for lists
  document.querySelectorAll(".items-container").forEach(list => {
    list.addEventListener("keydown", event => {
      if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
        event.preventDefault()
        const scrollStep = list.clientWidth / 2
        list.scrollBy({
          left: event.key === "ArrowRight" ? scrollStep : -scrollStep,
          behavior: "smooth",
        })
      }
    })
  })
}
document.addEventListener("DOMContentLoaded", initTabs)
